export const BACKGROUND_COLOR = Styles.color.contrastBackground;
export const USE_BACKGROUND_IMAGE = true;
export const DASHBOARD_PADDING_SIZE = '1rem';
export const DASHBOARD_PADDING_SIZE_TOP = '3.25rem';
